import React, { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import './FormaPagos.css';

const FormaPago = () => {
  const [metodoSeleccionado, setMetodoSeleccionado] = useState(null);
  const [carrito, setCarrito] = useState([]);
  const [metodosPago, setMetodosPago] = useState([]);
  const [nombre, setNombre] = useState('');
  const [dni, setDni] = useState('');
  const [email, setEmail] = useState('');
  const [telefono, setTelefono] = useState('');
  const [modalVisible, setModalVisible] = useState(false);
  const [cursosResumen, setCursosResumen] = useState('');
  const [respNombre, setRespNombre] = useState('');
  const [respDni, setRespDni] = useState('');
  const [respEmail, setRespEmail] = useState('');

  useEffect(() => {
    cargarMetodosPago();
    cargarCarrito();
  }, []);

  const mostrarNotificacion = (mensaje, tipo = 'error') => {
  const notificacion = document.createElement('div');
  notificacion.textContent = mensaje;
  const color = tipo === 'error' ? '#c8102e' : '#10b981';
  notificacion.style.cssText = `
    position: fixed;
    top: 80px;
    left: 50%;
    transform: translateX(-50%);
    background: ${color};
    color: white;
    padding: 12px 24px;
    border-radius: 8px;
    z-index: 999999;
    font-size: 14px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.2);
    white-space: nowrap;
  `;
  document.body.appendChild(notificacion);
  setTimeout(() => notificacion.remove(), 3000);
};

  const cargarMetodosPago = async () => {
    const { data } = await supabase
      .from('metodos_pago')
      .select('*')
      .eq('activo', true)
      .order('orden', { ascending: true });
    if (data) setMetodosPago(data);
  };

  const cargarCarrito = () => {
    const guardado = localStorage.getItem('carrito');
    if (guardado) {
      setCarrito(JSON.parse(guardado));
    }
  };

  const guardarCarrito = (nuevoCarrito) => {
    setCarrito(nuevoCarrito);
    localStorage.setItem('carrito', JSON.stringify(nuevoCarrito));
  };

const renderizarCarrito = () => {
  // CUANDO EL CARRITO ESTÁ VACÍO
  if (carrito.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: '2rem' }}>
        🛒 No hay cursos en el carrito.
        <br /><br />
        <button 
          className="btn-seguir-comprando" 
          onClick={() => window.location.href = '/cursos-compras'}
        >
          Ver cursos
        </button>
      </div>
    );
  }

  let total = 0;
  
  return (
    <>
      {/* Versión para desktop: tabla normal */}
      <div className="desktop-table">
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={{ textAlign: 'left', padding: '10px 8px', borderBottom: '2px solid #e2e8f0' }}>Curso</th>
              <th style={{ textAlign: 'center', padding: '10px 8px', borderBottom: '2px solid #e2e8f0' }}>Cantidad</th>
              <th style={{ textAlign: 'right', padding: '10px 8px', borderBottom: '2px solid #e2e8f0' }}>Precio</th>
              <th style={{ textAlign: 'center', padding: '10px 8px', borderBottom: '2px solid #e2e8f0' }}>Acción</th>
            </tr>
          </thead>
          <tbody>
            {carrito.map(curso => {
              const subtotal = curso.precio * (curso.cantidad || 1);
              total += subtotal;
              const cantidad = curso.cantidad || 1;
              const mostrarMenos = cantidad > 1;

              return (
                <tr key={curso.id}>
                  <td style={{ padding: '10px 8px', borderBottom: '1px solid #eef2ff', verticalAlign: 'middle' }}>
                    📚 {curso.nombre}
                  </td>
                  <td style={{ textAlign: 'center', padding: '10px 8px', borderBottom: '1px solid #eef2ff', verticalAlign: 'middle' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                      {mostrarMenos && (
                        <button 
                          className="btn-cantidad-menos"
                          onClick={() => actualizarCantidad(curso.id, -1)}
                          style={{ background: '#f1f5f9', border: '1px solid #e2e8f0', width: '28px', height: '28px', borderRadius: '6px', cursor: 'pointer' }}
                        >-</button>
                      )}
                      {!mostrarMenos && <div style={{ width: '28px' }}></div>}
                      <span style={{ minWidth: '35px', textAlign: 'center' }}>{cantidad}</span>
                      <button 
                        className="btn-cantidad-mas"
                        onClick={() => actualizarCantidad(curso.id, 1)}
                        style={{ background: '#f1f5f9', border: '1px solid #e2e8f0', width: '28px', height: '28px', borderRadius: '6px', cursor: 'pointer' }}
                      >+</button>
                    </div>
                  </td>
                  <td style={{ textAlign: 'right', padding: '10px 8px', borderBottom: '1px solid #eef2ff', verticalAlign: 'middle' }}>
                    S/ {subtotal.toFixed(2)}
                  </td>
                  <td style={{ textAlign: 'center', padding: '10px 8px', borderBottom: '1px solid #eef2ff', verticalAlign: 'middle' }}>
                    <button 
                      className="btn-eliminar-curso"
                      onClick={() => eliminarDelCarrito(curso.id)}
                      style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#c8102e', fontSize: '1.2rem' }}
                    >🗑️</button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Versión para móvil: tarjetas verticales */}
      <div className="mobile-cards">
        {carrito.map(curso => {
          const subtotal = curso.precio * (curso.cantidad || 1);
          total = carrito.reduce((sum, i) => sum + (i.precio * (i.cantidad || 1)), 0);
          const cantidad = curso.cantidad || 1;
          const mostrarMenos = cantidad > 1;

          return (
            <div key={curso.id} className="curso-card-mobile">
              <div className="curso-card-header">
                <span className="curso-icono">📚</span>
                <span className="curso-nombre-mobile">{curso.nombre}</span>
                <button 
                  className="btn-eliminar-mobile"
                  onClick={() => eliminarDelCarrito(curso.id)}
                >🗑️</button>
              </div>
              <div className="curso-card-body">
                <div className="curso-card-row">
                  <span className="label">Cantidad:</span>
                  <div className="cantidad-controls">
                    {mostrarMenos && (
                      <button onClick={() => actualizarCantidad(curso.id, -1)}>-</button>
                    )}
                    <span>{cantidad}</span>
                    <button onClick={() => actualizarCantidad(curso.id, 1)}>+</button>
                  </div>
                </div>
                <div className="curso-card-row">
                  <span className="label">Precio:</span>
                  <span className="precio-mobile">S/ {subtotal.toFixed(2)}</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      
      <div className="carrito-resumen">
        <div className="resumen-linea total">
          <span>Total a pagar:</span>
          <span>S/ {total.toFixed(2)}</span>
        </div>
      </div>
      <button className="btn-seguir-comprando" onClick={() => window.location.href = '/cursos-compras'}>
        + Agregar más cursos
      </button>
    </>
  );
};

  const actualizarCantidad = (id, delta) => {
    const nuevoCarrito = carrito.map(item => {
      if (item.id === id) {
        const nuevaCantidad = (item.cantidad || 1) + delta;
        if (nuevaCantidad <= 0) return null;
        return { ...item, cantidad: nuevaCantidad };
      }
      return item;
    }).filter(item => item !== null);
    guardarCarrito(nuevoCarrito);
  };

  const eliminarDelCarrito = (id) => {
    const nuevoCarrito = carrito.filter(item => item.id !== id);
    guardarCarrito(nuevoCarrito);
  };

  const actualizarCamposPorMetodo = (metodo) => {
    const datosYape = document.getElementById('datosYape');
    const datosPlin = document.getElementById('datosPlin');
    const datosBCP = document.getElementById('datosBCP');
    const datosVisa = document.getElementById('datosVisa');
    
    if (datosYape) datosYape.style.display = 'none';
    if (datosPlin) datosPlin.style.display = 'none';
    if (datosBCP) datosBCP.style.display = 'none';
    if (datosVisa) datosVisa.style.display = 'none';
    
    if (metodo === 'Yape' && datosYape) datosYape.style.display = 'block';
    else if (metodo === 'Plin' && datosPlin) datosPlin.style.display = 'block';
    else if (metodo === 'BCP' && datosBCP) datosBCP.style.display = 'block';
    else if (metodo === 'Visa' && datosVisa) datosVisa.style.display = 'block';
  };

  const validarDNI = (dni) => /^[0-9]{8}$/.test(dni);
  const validarEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const validarNombre = (nombre) => /^[a-zA-ZáéíóúñÑ\s]{3,}$/.test(nombre);
  const validarTelefono = (telefono) => telefono && /^[0-9]{9}$/.test(telefono) && telefono.startsWith('9');

const enviarComprobante = async () => {
  if (!nombre || !validarNombre(nombre)) {
    mostrarNotificacion('⚠️ Ingresa un nombre válido (mínimo 3 letras)');
    return;
  }
  if (!dni || !validarDNI(dni)) {
    mostrarNotificacion('⚠️ Ingresa un DNI válido (8 dígitos)');
    return;
  }
  if (!email || !validarEmail(email)) {
    mostrarNotificacion('⚠️ Ingresa un correo electrónico válido');
    return;
  }
  if (!validarTelefono(telefono)) {
    mostrarNotificacion('⚠️ El teléfono es obligatorio. Ingresa 9 dígitos (empieza con 9)');
    return;
  }
  if (carrito.length === 0) {
    mostrarNotificacion('🛒 No hay cursos en el carrito');
    return;
  }
  if (!metodoSeleccionado) {
    mostrarNotificacion('⚠️ Selecciona un método de pago');
    return;
  }

  const total = carrito.reduce((sum, i) => sum + (i.precio * (i.cantidad || 1)), 0);
  const ahora = new Date();
  const fechaPeru = new Date(ahora.getTime() - (5 * 60 * 60 * 1000)).toISOString().slice(0, 19);
  
  const { error } = await supabase.from('compras').insert([{
    nombre, dni, email, telefono,
    metodo_pago: metodoSeleccionado,
    total, cursos: carrito,
    estado: 'pendiente',
    fecha: fechaPeru
  }]);

  if (error) {
    mostrarNotificacion('❌ Error al registrar la compra: ' + error.message);
    return;
  }

  const cursosTexto = carrito.map(c => `${c.nombre} (x${c.cantidad || 1})`).join(', ');
  const numeroEmpresa = '51945504555';
  const mensaje = `*NUEVO PAGO REALIZADO*%0A` +
    `*Método:* ${metodoSeleccionado}%0A` +
    `*Cliente:* ${nombre}%0A` +
    `*DNI:* ${dni}%0A` +
    `*Correo:* ${email}%0A` +
    `*Teléfono:* ${telefono || 'No especificado'}%0A` +
    `*Monto:* S/ ${total}%0A` +
    `*Cursos:* ${cursosTexto}%0A%0A` +
    `Adjunto el comprobante de pago.`;

  window.open(`https://wa.me/${numeroEmpresa}?text=${mensaje}`, '_blank');

  localStorage.removeItem('carrito');
  setCarrito([]);
  
  setCursosResumen(cursosTexto);
  setRespNombre(nombre);
  setRespDni(dni);
  setRespEmail(email);
  setModalVisible(true);
};

  const cerrarModal = () => {
    setModalVisible(false);
    window.location.href = '/cursos-compras';
  };

  return (
    <div className="checkout-vertical">
      {/* SECCIÓN CURSOS (carrito) */}
      <div className="seccion-cursos">
        <h2 className="seccion-titulo">📚 Tus cursos</h2>
        {renderizarCarrito()}
      </div>

      {/* SECCIÓN FORMAS DE PAGO */}
      {carrito.length > 0 && (
        <div className="seccion-pago-completa">
          <h2 className="seccion-titulo">💰 Formas de pago</h2>
          
          {/* YAPE Y PLIN (juntos arriba) */}
          <div className="metodos-grid">
            {metodosPago.filter(m => m.nombre === 'Yape' || m.nombre === 'Plin').map(metodo => (
              <div 
                key={metodo.id}
                className={`metodo-card ${metodoSeleccionado === metodo.nombre ? 'seleccionado' : ''}`}
                data-metodo={metodo.nombre}
                onClick={() => {
                  setMetodoSeleccionado(metodo.nombre);
                  actualizarCamposPorMetodo(metodo.nombre);
                }}
              >
                <div className="metodo-radio"><span className="radio-circle"></span></div>
                <div className="metodo-icono">{metodo.icono}</div>
                <div className="metodo-info">
                  <strong>{metodo.nombre}</strong>
                  <small>{metodo.descripcion}</small>
                </div>
              </div>
            ))}
          </div>

          {/* BCP, VISA */}
          <div className="metodos-grid">
            {metodosPago.filter(m => m.nombre !== 'Yape' && m.nombre !== 'Plin').map(metodo => (
              <div 
                key={metodo.id}
                className={`metodo-card ${metodoSeleccionado === metodo.nombre ? 'seleccionado' : ''}`}
                data-metodo={metodo.nombre}
                onClick={() => {
                  setMetodoSeleccionado(metodo.nombre);
                  actualizarCamposPorMetodo(metodo.nombre);
                }}
              >
                <div className="metodo-radio"><span className="radio-circle"></span></div>
                <div className="metodo-icono">{metodo.icono}</div>
                <div className="metodo-info">
                  <strong>{metodo.nombre}</strong>
                  <small>{metodo.descripcion}</small>
                </div>
              </div>
            ))}
          </div>

          {/* DATOS YAPE */}
          <div id="datosYape" className="datos-metodo" style={{ display: 'none' }}>
            <div className="info-yape">
              <div className="qr-container">
                <img src="/img/yape.jfif" alt="Código QR Yape" className="qr-imagen" />
              </div>
              <div className="datos-cuenta">
                <p><strong>Número:</strong> {metodosPago.find(m => m.nombre === 'Yape')?.numero === 'Proximamente' ? '📌 Próximamente' : (metodosPago.find(m => m.nombre === 'Yape')?.numero || '📌 Próximamente')}</p>
                <p><strong>Titular:</strong> Instituto IGC</p>
              </div>
            </div>
          </div>

          {/* DATOS PLIN */}
          <div id="datosPlin" className="datos-metodo" style={{ display: 'none' }}>
            <div className="info-yape">
              <div className="qr-container">
                <img src="/img/plin.jpg" alt="Código QR Plin" className="qr-imagen" />
              </div>
              <div className="datos-cuenta">
                <p><strong>Número:</strong> {metodosPago.find(m => m.nombre === 'Plin')?.numero === 'Proximamente' ? '📌 Próximamente' : (metodosPago.find(m => m.nombre === 'Plin')?.numero || '📌 Próximamente')}</p>
                <p><strong>Titular:</strong> Instituto IGC</p>
              </div>
            </div>
          </div>

          {/* DATOS BCP */}
          <div id="datosBCP" className="datos-metodo" style={{ display: 'none' }}>
            <div className="info-banco">
              <div className="img-bcp">
                <img src="/img/bcp.png" alt="BCP" className="bcp-imagen" />
              </div>
              <p><strong>BCP:</strong> {metodosPago.find(m => m.nombre === 'BCP')?.numero === 'Proximamente' ? '📌 Próximamente' : (metodosPago.find(m => m.nombre === 'BCP')?.numero || '📌 Próximamente')}</p>
              <p><strong>CCI:</strong> {metodosPago.find(m => m.nombre === 'BCP')?.cci === 'Proximamente' || !metodosPago.find(m => m.nombre === 'BCP')?.cci ? '📌 Próximamente' : metodosPago.find(m => m.nombre === 'BCP')?.cci}</p>
              <p><strong>Titular:</strong> {metodosPago.find(m => m.nombre === 'BCP')?.titular || 'Instituto IGC'}</p>
            </div>
          </div>

          {/* DATOS VISA */}
          <div id="datosVisa" className="datos-metodo" style={{ display: 'none' }}>
            <div className="info-banco">
              <div className="img-visa">
                <img src="/img/visa.png" alt="Visa" className="visa-imagen" />
              </div>
              <p><strong>Visa:</strong> {metodosPago.find(m => m.nombre === 'Visa')?.numero === 'Proximamente' ? '📌 Próximamente' : (metodosPago.find(m => m.nombre === 'Visa')?.numero || '📌 Próximamente')}</p>
              <p><strong>Titular:</strong> Instituto IGC</p>
            </div>
          </div>

          {/* DATOS DEL COMPRADOR */}
          <div className="datos-comprador">
            <h3>📋 Datos del comprador</h3>
            <div className="form-row">
              <div className="form-group">
                <label>Nombre completo <span style={{ color: '#c8102e' }}>*</span></label>
                <input 
                  type="text" 
                  id="nombre" 
                  placeholder="Ej: Juan Pérez" 
                  className="input-field" 
                  value={nombre}
                  onChange={(e) => setNombre(e.target.value)}
                />
              </div>
              <div className="form-group">
                <label>DNI <span style={{ color: '#c8102e' }}>*</span></label>
                <input 
                  type="text" 
                  id="dni" 
                  placeholder="Ej: 12345678" 
                  className="input-field" 
                  value={dni}
                  onChange={(e) => setDni(e.target.value)}
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Correo electrónico <span style={{ color: '#c8102e' }}>*</span></label>
                <input 
                  type="email" 
                  id="email" 
                  placeholder="Ej: juan@correo.com" 
                  className="input-field" 
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className="form-group">
                <label>Teléfono <span style={{ color: '#c8102e' }}>*</span></label>
                <input 
                  type="tel" 
                  id="telefono" 
                  placeholder="Ej: 987654321" 
                  className="input-field" 
                  inputMode="numeric"
                  value={telefono}
                  onChange={(e) => setTelefono(e.target.value)}
                />
              </div>
            </div>
          </div>

          {/* BOTÓN YA PAGUÉ */}
          <button id="btnEnviarComprobante" className="btn-enviar-comprobante" onClick={enviarComprobante}>
            ✅ Ya pagué, enviar comprobante
          </button>
        </div>
      )}

      {/* MODAL */}
      {modalVisible && (
        <div className="modal" style={{ display: 'flex' }}>
          <div className="modal-contenido">
            <span className="modal-cerrar" onClick={cerrarModal}>&times;</span>
            <div className="modal-icono">🎉</div>
            <h3>¡Compra registrada!</h3>
            <p><strong>{cursosResumen}</strong></p>
            <p>Método: <span>{metodoSeleccionado}</span></p>
            <div className="datos-registrados">
              <p><strong>Nombre:</strong> {respNombre}</p>
              <p><strong>DNI:</strong> {respDni}</p>
              <p><strong>Email:</strong> {respEmail}</p>
            </div>
            <button className="btn-cerrar-modal" onClick={cerrarModal}>Cerrar</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default FormaPago;